import { Request } from '@/classes/Request.ts'

// One payment the next nightly invoice-due-date run would charge (DTA-772).
export interface InvoiceDueDatePreviewPayment {
  type: 'contract' | 'invoice'
  name: string
  invoice_header_id: number
  due_date: string
  amount: number
}

// What switching to "By Contract Invoice Due Date" would charge that night, for the
// contracts that will be on auto pay once saved.
export const invoiceDueDatePreview = async (
  districtId: TDistrictId,
  contractIds: number[]
): Promise<InvoiceDueDatePreviewPayment[]> => {
  const result = await new Request().post(
    `/ajax/auto_payment_settings/invoice_due_date_preview/${districtId}`,
    { contract_ids: contractIds }
  )
  if (!result.data?.success) {
    throw new Error(result.data?.failure_reason ?? 'invoice due date preview failed')
  }
  return result.data.payments ?? []
}
